import moment from "moment";
export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: false,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: true,
    /** 索引说明 */
    indexLabel: "No",
    /** 表格搜索显隐按钮 */
    searchShowBtn: false,
    /** 是否启用功能按钮 */
    searchIcon: false,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 表格搜索按钮 */
    searchBtn: false,
    /** 表格清空按钮 */
    emptyBtn: false,
    /** 表格列操作按钮 */
    columnBtn: false,
    /** 表格刷新数据按钮 */
    refreshBtn: false,
    /** 开启拖拽功能 */
    sortable: true,
    // dragHandler: true,
    rowSort: true,
    columnSort: true,
    menuWidth: 240,
    column: [

      {
        label: "乐播片花 ID",
        prop: "id"
      },
      {
        label: "片花名称",
        prop: "aword",
      },
      {
        label: "类型",
        prop: "type",
        formatter: (val) => {
          return ["其它", "片花/花絮", "预告片", "高能看点", "二次创作", "一般关系"][+val.type]
        }
      },
      {
        label: "片花状态",
        prop: "status",
        formatter: (val) => {
          return ["下线", "上线"][+val.status]
        }
      },
      {
        label: "时长",
        prop: "duration",
        formatter: val => {
          const duration = moment.duration(val.duration, "seconds");
          return (
            duration
              .hours()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .minutes()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .seconds()
              .toString()
              .padStart(2, "0")
          );
        }
      },

      {
        label: "更新时间",
        prop: "updateTime"
      },
      // {
      //   label: "",
      //   prop: "my",
      //   hide: true,
      //   showColumn: false,
      //   search: true,
      //   display: false,
      //   menuClassName: "myClass",
      //   searchslot: true
      // }
    ]
  };
  // return {
  //   title: '表格的标题',
  //   sortable: true,
  //   dragHandler: true,
  //   border: true,
  //   align: 'center',
  //   menuAlign: 'center',
  //   column: [
  //     {
  //       label: '姓名',
  //       prop: 'name'
  //     },
  //     {
  //       label: '性别',
  //       prop: 'sex'
  //     },
  //     {
  //       label: '日期',
  //       prop: 'date',
  //       type: 'date',
  //       format: 'yyyy-MM-dd hh:mm:ss',
  //       valueFormat: 'yyyy-MM-dd hh:mm:ss'
  //     }
  //   ]
  // };
};
